import { Component, Input, effect, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { RequestType } from '@app/v2/enums/request-types.enum';
import {
    EditableCardComponent,
    EditableCardMode,
} from '@components/atoms/medpace-editable-card/medpace-editable-card.component';
import { NoteCardElement } from './note-card-element';
import { NoteCardElementFormGroup, NoteCardFormGroup } from './note-card.formgroup';

import { DateFormat } from '@models/date-format';
import { NoteStore } from './note.store';

export enum NoteCardContext {
    Site = 'Site',
    Patient = 'Patient',
    Travel = RequestType.Travel,
    Stipend = RequestType.Stipend,
    Reimbursement = RequestType.Reimbursement,
}
@Component({
    selector: 'medpace-note-card',
    templateUrl: './note-card.component.html',
    styleUrl: './note-card.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class NoteCardComponent extends EditableCardComponent<NoteCardElement[]> {
    @Input() mode: EditableCardMode = 'view';
    @Input() showSwitchModeButton: boolean = true;

    context = input<NoteCardContext | null>(null);

    notes = input<NoteCardElement[] | null>(null);
    a = effect(
        () => {
            if (this.notes() == null) return;
            this.formGroup.setValueFromModel(this.notes());
            if (this.context() === NoteCardContext.Patient) this.noteStore.setPatientNotesFormGroup(this.formGroup);
            else if (this.context() === NoteCardContext.Site) this.noteStore.setSiteNotesFormGroup(this.formGroup);
        },
        {
            allowSignalWrites: true,
        }
    );

    @Input() title: string = 'Site Note';

    noteStore = inject(NoteStore);

    formGroup = new NoteCardFormGroup();

    constructor() {
        super();
    }

    public getOutputData(): NoteCardElement[] {
        return this.formGroup.getModelFromValue();
    }

    addNote() {
        const control = new NoteCardElementFormGroup();

        control.setValueFromModel({ id: 0, note: '', modifiedInitials: '', modifiedTime: null });

        this.formGroup.controls.notes.push(control);
    }

    protected override canChangeMode(mode: EditableCardMode): boolean {
        return mode === 'edit' || this.formGroup.valid;
    }

    protected override onModeChangeFail(mode: EditableCardMode) {
        this.formGroup.markAllAsTouched();
        // buildSnackBar(collectErrors(this.formGroup), this.snackbarService);
    }

    removeNote(formGroupIndex: number) {
        this.formGroup.controls.notes.removeAt(formGroupIndex);
    }

    datetime12 = DateFormat.dateTime12;
}
